export default __webpack_public_path__ + "static/media/5.77997c71.jpg";